export default __webpack_public_path__ + "static/media/a037-student-t3-7.e710dd0a.svg";